'use strict';

;(function($) {

  const tableToggles = document.querySelectorAll('[data-toggle="tableau"]');

  /* determine if element is in viewport (offset by 100px) */
  function inViewport(element) {
    const rect = element.getBoundingClientRect();
    const elementHeight = rect.bottom - rect.top;

    /* if element is within an accordion */
    if(rect.top === 0 && rect.bottom === 0) {
      return false;
    }

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) + (elementHeight * 2)) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  /* load the tableaus that are in the viewport */
  function loadTableau() {
    const tableaus = document.querySelectorAll('.tableauLoad');

    for (let i = 0; i < tableaus.length; i++) {
      if( inViewport(tableaus[i]) ) {
        const html = `
          <div class="tableau-container" style="width: ${tableaus[i].style.width}; height: ${tableaus[i].style.height}">
            <iframe src="${tableaus[i].dataset.src}" frameborder="0" scrolling="no"></iframe>
          </div>
        `;

        tableaus[i].parentNode.innerHTML = html;
      }
    }
  }

  for (let i = 0; i < tableToggles.length; i++) {
    tableToggles[i].addEventListener('click', loadTableau);
  }

  /* event listeners */
  window.addEventListener('load', loadTableau);
  window.addEventListener('scroll', loadTableau);

})(jQuery);
